/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Existing/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import PatientPreview from './PatientPreview/index'
import PatientSelect from './PatientSelect/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Existing({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/Existing"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'PatientSelect'
let appointmentOverlayPatientIdValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_overlay',
path: 'patient_id',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: appointmentOverlayPatientIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'PatientSelect'}>
<PatientSelect
  viewPath={`${viewPath}/PatientSelect`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientPreview'}>
<PatientPreview
  viewPath={`${viewPath}/PatientPreview`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}